import React from "react";
import Chart from "react-apexcharts";

export default function BudgetDistributionChart({data}) {
  // const data = [
  //   {
  //     name: "Housing",
  //     quantity: 17.0,
  //   },
  //   {
  //     name: "Infrastructure",
  //     quantity: 17.0,
  //   },
  //   {
  //     name: "Defense",
  //     quantity: 16.0,
  //   },
  //   {
  //     name: "Healthcare",
  //     quantity: 22.0,
  //   },
  //   {
  //     name: "Education",
  //     quantity: 20.0,
  //   },
  //   {
  //     name: "Technology",
  //     quantity: 8.0,
  //   },
  // ];

  const totalBudget = data?.reduce((sum, item) => sum + item.totalSpentBudget, 0);
  const names = data?.map(n => n?.areaName);
  const quantities = data?.map(
    (item) => parseFloat(((item.totalSpentBudget / totalBudget) * 100).toFixed(1)) // Round to 2 decimal places
  );


  const options = {
    labels: names,
    legend: {
      show: false,
    },
    colors: ["#094DC3", "#3C79D9", "#6D9AE3", "#9DBCEC", "#CEDDF6", "#EAF2FF"],
    chart: {
      type: "pie",
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        // const name = opts.w.config.labels[opts.seriesIndex];
        return `${val.toLocaleString()}%`;
      },
      style: {
        fontSize: '14px',
        colors: ['#000'],
        fontWeight: 'normal'
      },
      dropShadow: {
        enabled: false
      },
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return `${val}%`;
        },
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
            offset: -20,
          },
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: "350",
          },
        },
      },
      {
        breakpoint: 420,
        options: {
          chart: {
            width: "270",
          },
          dataLabels: {
            style: {
              fontSize: '10px',
            },
          },
        },
      },
    ]
  };

  const series = quantities;

  return <Chart options={options} series={series} type="pie" width="500" />;
}
